
<lib-drools [RBACORG]="RBACORG" [PERMISSION]="PERMISSION" [COMMONSERVICE]="COMMONSERVICE"></lib-drools>

